import { render } from "./CometChatSenderImageMessageBubble.vue?vue&type=template&id=76384295&scoped=true"
import script from "./CometChatSenderImageMessageBubble.vue?vue&type=script&lang=js"
export * from "./CometChatSenderImageMessageBubble.vue?vue&type=script&lang=js"

import "./CometChatSenderImageMessageBubble.vue?vue&type=style&index=0&id=76384295&scoped=true&lang=css"
import "./CometChatSenderImageMessageBubble.vue?vue&type=style&index=1&id=76384295&lang=css"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76384295"]])

export default __exports__